import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const BobaU4T = () => (
  <ArticleWrapper articleId="boba_u4t">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Boba U4T</h1>
      {/* Add your Boba U4T article content here */}
      <p>This is a placeholder article for the Boba U4T switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default BobaU4T;
